import { Component, inject, Injector } from '@angular/core';
import {NgElement, WithProperties} from '@angular/elements';
import { APP_CONFIG } from '../environments/environment.injection.token';

@Component({
  selector: 'app-root',
  imports: [],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent {
  private readonly appConfig = inject(APP_CONFIG);
  injector: Injector = inject(Injector);

  constructor() {    
    if(!this.appConfig.production) {
      const paywall = document.createElement('paywall-main') as NgElement & WithProperties<{text: string}>;
      paywall.setAttribute('token','ZDQwZGYyY2MtNTdhNi00ZjYxLTc3NzMtMDhkZjBlNWQxMzA2LDgxMTAzYTUxLWY1ZmItZWUxMS1hYWYwLTAwMGQzYTQ0ODhlZCxmYTI5Y2Y2MS0yZTczLTRlMTEtYmVjYy01MjA0OGI1YWY1YTA=');
      paywall.setAttribute('api-url', this.appConfig.dataUrl);
      document.body.appendChild(paywall);
    }
  }
}
  